import React from "react";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { Image, ImageProps } from "../../components/Image/Image";
import { IconLinksCards, Props as IconLinksCardProps } from "../../components/IconLinksCards/IconLinksCards";
import { GroupedComponents } from "../../components/GroupedComponents";
import { ParagraphCard } from "../../components/ParagraphCard";
import { LinksProps } from "../../components/Links";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";

export interface ElectricityLandingPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  serviceCards?: IconLinksCardProps;
  images?: ImageProps[];
  linksList?: LinksProps[];
  faqs?: FaqAccordionGroupProps;
}

export const ElectricityLandingPage: React.FC<ElectricityLandingPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  serviceCards,
  images,
  linksList,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && linksList && linksList[0] && <ParagraphCard paragraph={paragraphs[0]} linkList={linksList[0]} />}
      <GroupedComponents>
        {serviceCards && <IconLinksCards {...serviceCards} />}
        {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      </GroupedComponents>
      {images && images[0] && <Image {...images[0]} />}
      {paragraphs && paragraphs[2] && <Paragraph {...paragraphs[2]} />}
    </ServiceCataloguePageWrapper>
  );
};
